<template>
  <div class="fixed">
    <div class="loading"><i class="iconfont">&#xe627;</i></div>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>
